/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, next: NonNullable<unknown> }} Plan_Edit_Superset_UnlinkInputs */

const en_us2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Separate ${i?.name} from ${i?.next}`)
};

const pt_br2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Separar ${i?.name} de ${i?.next}`)
};

const es_419_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Separar ${i?.name} de ${i?.next}`)
};

const pt_pt2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Separar ${i?.name} de ${i?.next}`)
};

const fr_fr2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séparer ${i?.name} de ${i?.next}`)
};

const de_de2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} von ${i?.next} trennen`)
};

const it_it2_plan_edit_superset_unlink = /** @type {(inputs: Plan_Edit_Superset_UnlinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Separa ${i?.name} da ${i?.next}`)
};

/**
* | output |
* | --- |
* | "Separate {name} from {next}" |
*
* @param {Plan_Edit_Superset_UnlinkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_superset_unlink = /** @type {((inputs: Plan_Edit_Superset_UnlinkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Superset_UnlinkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_superset_unlink(inputs)
	if (locale === "es-419") return es_419_plan_edit_superset_unlink(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_superset_unlink(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_superset_unlink(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_superset_unlink(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_superset_unlink(inputs)
	return en_us2_plan_edit_superset_unlink(inputs)
});
export { plan_edit_superset_unlink as "plan-edit.superset_unlink" }